<!-- Loader starts-->
<div class="overlay" *ngIf="show">
  <div class="overlay__wrapper">
    <div class="spinner-border" role="status" style="width: 3rem; height: 3rem; z-index: 20;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
<!-- Loader ends-->
